const utils = require("./index");
const auth = require("./auth").default;
import axios from "axios";

const CLIENT_ID = 2;

const NOTIFICATION_TYPE_MAP = {
	BET_PLACEMENT: (type) => {
		return {
			type,
			title:
				type == "error" ? "Bet Placement Failed" : "Bet Placement Successful",
			clickAction: type == "error" ? "RELOAD_BETSLIP" : "GO_TO_BETSLIP",
		};
	},
	BET_WON: (type) => {
		return {
			type,
			title: type == "error" ? "Bet Result" : "Congratulations!",
			clickAction: "GO_TO_BETSLIP",
		};
	},
	BET_CANCELLED: (type) => {
		return {
			type,
			title:
				type == "error"
					? "Bet Cancellation Failed"
					: "Bet Cancellation Successful!",
			clickAction: "GO_TO_BETSLIP",
		};
	},
	FREEBET: (type) => {
		return {
			type,
			title: type == "error" ? "Promotion Expired" : "Promotion",
			clickAction: "OPEN_PROMO_DETAIL",
		};
	},
};

const ACTIONS = {
	GO_TO_BETSLIP: (params) => {
		if (!params.bet_id) return null;
		return {
			title: "View Bet",
			type: "button",
			cb: () => {
				let readNotificationEvent = new Event("readNotification");
				console.log(
					"[Notification] Dispatching event...",
					readNotificationEvent
				);
				window.dispatchEvent(readNotificationEvent);
				window.location.href = `#/mybets/${params.bet_id}?category=normal_bet`;
			},
		};
	},
	RELOAD_BETSLIP: (params) => {
		if (!params.bet_ref) return null;
		return {
			title: "Retry Bet",
			type: "button",
			cb: () => {
				let readNotificationEvent = new Event("readNotification");
				console.log(
					"[Notification] Dispatching event...",
					readNotificationEvent
				);
				window.dispatchEvent(readNotificationEvent);
				window.location.href = `#/betslip?ref=${params.bet_ref}`;
			},
		};
	},
	OPEN_PROMO_DETAIL: (params) => {
		if (!params.free_bet_id) return null;
		return {
			title: "View Freebet",
			type: "button",
			cb: () => {
				let readNotificationEvent = new Event("readNotification");
				console.log(
					"[Notification] Dispatching event...",
					readNotificationEvent
				);
				window.dispatchEvent(readNotificationEvent);
				window.location.href = `#/freebets`;
			},
		};
	},
};

class Notifications {
	constructor() {
		this.socket = null;
		this.initializing = false;
		this.notificationQueue = [];
		this.wait = false;
		this.user_device_id = null;
		this.updateAuthDetails();
		this.initNotificationsView();
	}
	updateAuthDetails() {
		this.user_device_id = utils.cookie.get("user_device_id");
		this.user = auth.getUser();
		this.token = auth.getToken();
		this.isAuthenticated = auth.getAuthStatus();
	}
	registerDeviceForNotifications() {
		let vm = this;
		if (!vm.isAuthenticated || vm.initializing) return;
		vm.initializing = true;
		let method = "POST";

		let data = {
			client_id: CLIENT_ID,
			device_id: vm.user_device_id,
			user_device_id: vm.user_device_id,
			profile_id: vm.user["id"],
			status: 1,
			token: vm.token,
		};
		// console.log(`[Notifications] Registering device... data:`, data);

		if (vm.user_device_id) method = "PATCH"; // Already registered, just update with current user details

		const url = `${NOTIFICATIONS_API_URL}devices`;

		axios({ method, url, data })
			.then((res) => {
				// console.log(`[Notifications] res:`, res);
				vm.initializing = false;
				if ((res.status == 200 || res.status == 201) && !vm.user_device_id) {
					utils.cookie.set("user_device_id", res.data.user_device_id, 10 * 365); // Set cookie for 10yrs
					vm.user_device_id = res.data.user_device_id;
					console.log(
						`[Notifications] Registered device. user_device_id: ${vm.user_device_id}`
					);
					// vm.initSocket();
				} else {
					console.log(
						`[Notifications] Updated device. user_device_id: ${vm.user_device_id}`
					);
					// vm.initSocket();
				}
			})
			.catch((err) => {
				vm.initializing = false;
				console.warn("Failed to register device for notifications", err);
				// TODO: Implement retry mechanism
			});
	}
	initSocket() {
		let vm = this;
		if (vm.socket && vm.socket.connected) {
			console.log(
				`[SOCKET] Socket already exists. Status: ${vm.socket.connected}`
			);
			return;
		}
		console.log(
			`[SOCKET] Initializing socket with URL ${NOTIFICATIONS_SOCKET_URL}`
		);
		vm.socket = io(`${NOTIFICATIONS_SOCKET_URL}`, {
			transports: ["websocket"],
		});
		const deviceDetails = {
			client_id: CLIENT_ID,
			device_id: vm.user_device_id,
			user_device_id: vm.user_device_id,
			profile_id: vm.user ? vm.user.id : null,
			status: 1,
			token: vm.token,
			user_agent: window.navigator.userAgent,
		};
		vm.socket.on("connect", () => {
			console.log("[SOCKET] Connected");
			vm.socket.emit("update", deviceDetails);
		});
		vm.socket.on("broadcast", vm.handleBroadcast.bind(vm));
	}
	handleBroadcast(data) {
		let vm = this;
		console.log("[Notification] Got broadcast", data);
		let { message, room } = data;
		let payload = {
			room,
			notification_id: message.notification_id,
			user_device_id: vm.user_device_id,
		};
		vm.socket.emit("ack", payload);

		vm.add(vm.decorateNotification(message));
		let newNotificationEvent = new Event("newNotification");
		window.dispatchEvent(newNotificationEvent);
		console.log("[Notification] Dispatching event...", newNotificationEvent);
	}
	decorateNotification(notification) {
		const type = this.getType(notification);
		const action = this.getAction(notification, type);
		return {
			message: notification.message,
			type: type.type,
			action,
			title: type.title,
			duration: 30000,
		};
	}
	getType(notification) {
		const type = NOTIFICATION_TYPE_MAP[notification.type]
			? NOTIFICATION_TYPE_MAP[notification.type](notification.status)
			: null;
		return type
			? type
			: { message: notification.message, type: "info", action: null };

		// type: notification.status ? notification.status : "info",
	}
	getAction(notification, type) {
		return ACTIONS[type.clickAction]
			? ACTIONS[type.clickAction](notification.params)
			: null;
	}
	initNotificationsView() {
		this.notificationsEl = document.querySelector("#notifications-root");
	}
	getNotificationMarkup(message, type, action = null, title) {
		let vm = this;
		let notificationEl = document.createElement("div");
		notificationEl.classList.add("notification");
		notificationEl.classList.add("show");
		notificationEl.classList.add(type);

		// if(!title) title = `${type[0].toUpperCase()}${type.slice(1,type.length)}`

		if (title) {
			let titleEl = document.createElement("div");
			titleEl.classList.add("title");
			titleEl.innerHTML = title;
			notificationEl.appendChild(titleEl);
		}

		let closeEl = document.createElement("span");
		closeEl.classList.add("close");
		closeEl.innerHTML = "&times;";
		closeEl.addEventListener("click", () => {
			vm.close(notificationEl);
		});
		notificationEl.appendChild(closeEl);
		let messageEl = document.createElement("p");
		messageEl.classList.add("message");
		messageEl.innerHTML = message;
		notificationEl.appendChild(messageEl);

		if (action) {
			let actionContainerEl = document.createElement("div");
			actionContainerEl.classList.add("action__container");
			actionContainerEl.appendChild(vm.getActionMarkup(action, notificationEl));
			notificationEl.appendChild(actionContainerEl);
		}

		return notificationEl;
	}

	getActionMarkup(action, notificationEl) {
		let actionEl;
		let vm = this;
		if (action.type == "link") {
			actionEl = document.createElement("a");
			actionEl.classList.add("action");
			actionEl.classList.add("button");
			actionEl.classList.add("no-bg");
			actionEl.innerHTML = action.title;
			actionEl.href = action.route;
		} else if (action.type == "button") {
			actionEl = document.createElement("button");
			actionEl.classList.add("action");
			actionEl.classList.add("button");
			actionEl.classList.add("no-bg");
			actionEl.innerHTML = action.title;
			actionEl.onclick = actionEl.addEventListener("click", () => {
				action.cb();
				vm.close(notificationEl);
			});
		}
		return actionEl;
	}
	close(notification) {
		let vm = this;
		if (notification.parentNode == vm.notificationsEl)
			vm.notificationsEl.removeChild(notification);
		vm.wait = false;
	}
	add(notification) {
		console.log("[Notification] Showing notification", notification);
		const {
			message,
			type = "success",
			duration = null,
			action = null,
			title = null,
		} = notification;
		let vm = this;
		const markup = vm.getNotificationMarkup(message, type, action, title);
		vm.showNotification(markup, duration);
		// vm.notificationQueue.push({ markup, duration })
	}
	process() {
		let vm = this;
		setInterval(() => {
			console.log("wait", vm.wait, "queue", vm.notificationQueue);
			if (!vm.wait && vm.notificationQueue.length > 0) {
				const notification = vm.notificationQueue.pop();
				vm.showNotification(notification.markup, notification.duration);
			}
		}, 1000);
	}
	showNotification(notification, duration) {
		let vm = this;
		vm.wait = true;
		vm.notificationsEl.appendChild(notification);
		if (duration)
			setTimeout(() => {
				vm.close(notification);
			}, duration);
	}
	addNotificationBannerMessage(
		title,
		msg,
		actionLabel = "",
		actionUrl = "",
		image = null,
		dismissable = false,
		confirmDismissForever = false,
		basic = false,
		advanced = true
	) {
		let message = {
			title: title,
			msg: msg,
			actionLabel: actionLabel,
			actionUrl: actionUrl,
			image: image,
			dismissable: dismissable,
			confirmDismissForever: confirmDismissForever,
			basic: basic,
			advanced: advanced,
		};

		localStorage.setItem(
			"notification-banner-message",
			JSON.stringify(message)
		);
	}
}

const instance = new Notifications();

instance.registerDeviceForNotifications();

export default instance;
